import Vue from "vue";
import PaginatedService from "./paginated.service";

class ReceivablesService extends PaginatedService {
  static get resource() {
    return "admin/receivables";
  }

  static get_aggregate() {
    const url = `${this.resource}/aggregate`;

    return new Promise((resolve, reject) => {
      Vue.axios
        .get(url)
        .then(({ data }) => {
          resolve(data);
        })
        .catch((error) => {
          reject(error);
        });
    });
  }

  static getCurrencyAggregate(currency) {
    const url = `${this.resource}/aggregate`;

    let params = {"currency": currency};

    return new Promise((resolve, reject) => {
      Vue.axios
        .get(url, {params})
        .then(({ data }) => {
          resolve(data);
        })
        .catch((error) => {
          reject(error);
        });
    });
  }

  static get_analytics(slug, params) {
    const url = `${this.resource}/analytics/${slug}`;

    return new Promise((resolve, reject) => {
      Vue.axios
        .get(url, {params})
        .then(({ data }) => {
          resolve(data);
        })
        .catch((error) => {
          reject(error);
        });
    });
  }

  static get_top_customers() {
    const url = `${this.resource}/top-customers`;

    return new Promise((resolve, reject) => {
      Vue.axios
        .get(url)
        .then(({ data }) => {
          resolve(data);
        })
        .catch((error) => {
          reject(error);
        });
    });
  }
}

export default ReceivablesService;
